import blackProfessionalsImg from "../assets/images/black_professionals_canada_1787462325966.jpg";
import africanTalentsHeroImg from "../assets/images/african_talents_hero_1787462337381.jpg";

export const BLACK_PROFESSIONALS_IMAGE = blackProfessionalsImg;
export const AFRICAN_TALENTS_HERO_IMAGE = africanTalentsHeroImg;

export const PROFESSIONALS_IMAGE = blackProfessionalsImg;
export const STUDY_IMAGE = africanTalentsHeroImg;

export const TORONTO_WATERFRONT_IMAGE =
  "https://images.unsplash.com/photo-1697265772827-dee45b1add00?auto=format&fit=crop&w=1800&q=82";

export const CANADA_MAPLE_IMAGE =
  "https://images.unsplash.com/photo-1623039925698-1f96229b1a51?auto=format&fit=crop&w=1400&q=85";

export const MONTREAL_IMAGE =
  "https://images.unsplash.com/photo-1519178614-68673b201f36?auto=format&fit=crop&w=1600&q=86";
